import type { ModeDescriptions } from "../components/BreadcrumbDropdownMenu";

// Cycle Count mode vocabulary — kept in its own file (not inside
// CycleCountLayout.tsx) so navModeRegistry.ts can pull the slug/label map
// without eagerly bundling the layout component (and its MUI breadcrumb
// deps) into the nav chunk. Mirrors src/ads-and-sbs/modes.ts /
// src/modifications/modes.ts, which split the same way for the same reason.
//
// route slug -> legacy status CODE. The codes are the contract (they are
// what `parts_stock_tracker.status` stores); the slugs are URL-stable names
// for them. `all` passes no status at all rather than being a fifth code.
export const MODE_STATUS: { [slug: string]: number | undefined } = {
  all: undefined,
  "to-be-counted": 1,
  "count-entered": 2,
  closed: 0,
  cancelled: 3,
};

/** Fallback labels = the g2 `stock_tracker_status_list` values verbatim. Used
 *  only when the tenant's config vocab is unseeded (nav children have no live
 *  vocab context, so they always use these). */
export const FALLBACK_LABELS: { [slug: string]: string } = {
  all: "All Counts",
  "to-be-counted": "To be Counted",
  "count-entered": "Count Entered",
  closed: "Closed",
  cancelled: "Cancelled",
};

/**
 * Mode segment -> the grey line under its label in the breadcrumb dropdown
 * (BP-85, H76: "ALL model switchers should have name and description the same
 * as demand"). Same keys as the label map; each read off what the mode's
 * component renders, not paraphrased from the label.
 *
 * Keyed by SLUG, never by label: the labels are the tenant's own
 * `stock_tracker_status_list` vocab (FALLBACK_LABELS only when unseeded), so a
 * tenant can rename a mode — the description follows the status, not the word.
 */
export const MODE_DESCRIPTIONS: ModeDescriptions = {
  all: "Every count sheet",
  "to-be-counted": "Sheets awaiting a count",
  "count-entered": "Awaiting confirmation",
  closed: "Completed count sheets",
  cancelled: "Abandoned count sheets",
};
